export const eventsData = [
  [
    {
      name: "Tabletop Troupe: A Gathering on Adventure's Eve",
      pos: '0% 10%',
      zoom: '100%',
      image: 'Tabletop Troupe A Gathering on Adventures Eve.png',
      start: '2026-09-23 06:00:00',
      end: '2026-11-03 14:59:00',
      color: '#d6aa7f',
      url: 'https://www.hoyolab.com/article/46771528',
      showOnHome: true,
    },
  ],
  [
    {
      name: "Across the Frozen Wilds, Honing One's Edge",
      pos: '0% 10%',
      zoom: '100%',
      image: 'Across the Frozen Wilds Honing Ones Edge.png',
      start: '2026-09-23 06:00:00',
      end: '2026-11-03 14:59:00',
      color: '#d5f1ec',
      url: 'https://www.hoyolab.com/article/46771528',
      showOnHome: true,
    },
  ],
  [
    {
      name: 'Resplendent Starlight - Daily Login',
      pos: '0% 40%',
      zoom: '200%',
      image: 'Rainbows End Resplendent Starlight.png',
      start: '2026-10-01 04:00:00',
      end: '2026-10-19 03:59:00',
      color: '#87b1e2',
      url: 'https://www.hoyolab.com/article/46771533',
      showOnHome: true,
    },
  ],
  [
    {
      name: 'Missive of Grace: A Thank-You Gift',
      pos: '0% 40%',
      zoom: '200%',
      image: 'Rainbows End Resplendent Starlight.png',
      start: '2026-09-28 00:00:00',
      end: '2026-11-02 03:59:00',
      color: '#87b1e2',
      url: 'https://www.hoyolab.com/article/46771533',
      showOnHome: true,
    },
  ],
  [
    {
      name: 'Predictive Victory Dynamics',
      pos: '0% 60%',
      zoom: '300%',
      image: 'Predictive Victory Dynamics.png',
      start: '2026-10-11 22:00:00',
      end: '2026-10-19 21:59:00',
      color: '#fae280',
      url: 'https://www.hoyolab.com/article/47031716',
      showOnHome: true,
    },
    {
      name: 'Overflowing Favor',
      pos: '0% 60%',
      image: 'Overflowing Favor.png',
      start: '2026-10-26 04:00:00',
      end: '2026-11-02 03:59:59',
      color: '#d3f4fd',
      zoom: '200%',
      url: 'https://www.hoyolab.com/article/47058278',
      showOnHome: true,
    },
  ],
  [
    {
      name: 'Silverwing in Pursuit of the Moon',
      pos: '0% 30%',
      image: 'Silverwing in Pursuit of the Moon.png',
      start: '2026-09-24 10:00:00',
      end: '2026-10-12 03:59:59',
      color: '#d3d095',
      zoom: '150%',
      url: 'https://www.hoyolab.com/article/46782339',
      showOnHome: true,
    },
    {
      name: 'Carefree Snowball Fight',
      pos: '0% 0%',
      image: 'Carefree Snowball Fight.png',
      start: '2026-10-21 10:00:00',
      end: '2026-11-02 03:59:59',
      color: '#d9f0f8',
      zoom: '150%',
      url: 'https://www.hoyolab.com/article/47130835',
      showOnHome: true,
    },
    {
      name: 'The Grand Defense: Defy the Unjust Judgment',
      pos: '0% 30%',
      zoom: '100%',
      image: 'The Grand Defense Defy the Unjust Judgment.png',
      start: '2026-11-04 06:00:00',
      end: '2026-12-16 05:59:59',
      color: '#ddd0b0',
      url: 'https://www.hoyolab.com/article/47284166',
      timezoneDependent: true,
      showOnHome: true,
    },
  ],
  [
    {
      name: 'A Rekviem for the Underworld',
      pos: '0% 0%',
      zoom: '100%',
      image: 'A Rekviem for the Underworld.png',
      start: '2026-09-23 06:00:00',
      end: '2026-11-03 14:59:59',
      color: '#f25a69',
      url: 'https://www.hoyolab.com/article/46771527',
      showOnHome: true,
      timezoneDependent: true,
    },
    {
      name: 'Hour of Ruin',
      pos: '0% 0%',
      zoom: '100%',
      image: 'Hour of Ruin.png',
      start: '2026-11-04 06:00:00',
      end: '2026-12-15 14:59:59',
      color: '#abc3e3',
      url: 'https://www.hoyolab.com/article/47284167',
      showOnHome: true,
      timezoneDependent: true,
    },
  ],
  [
    {
      name: 'When Warm Winds Cavort - Vesna Banner',
      pos: '20% 12%',
      zoom: '200%',
      image: 'When Warm Winds Cavort 1.png',
      start: '2026-09-23 06:00:00',
      end: '2026-10-13 17:59:59',
      color: '#8dd6d9',
      url: 'https://www.hoyolab.com/article/46771531',
      timezoneDependent: true,
      showOnHome: true,
    },
    {
      name: "Void Star's Advent - Skirk Banner",
      pos: '20% 12%',
      zoom: '200%',
      image: 'Void Stars Advent 3.png',
      start: '2026-10-13 18:00:00',
      end: '2026-11-03 14:59:59',
      color: '#adcdff',
      url: 'https://www.hoyolab.com/article/47010361',
      showOnHome: true,
    },
    {
      name: 'Myriad Patterns Unfold - Mitya Banner',
      pos: '20% 12%',
      zoom: '200%',
      image: 'Myriad Patterns Unfold 1.png',
      start: '2026-11-04 06:00:00',
      end: '2026-11-24 17:59:59',
      color: '#aeadeb',
      url: 'https://www.hoyolab.com/article/47284168',
      timezoneDependent: true,
      showOnHome: true,
    },
  ],
  [
    {
      name: 'Surging Ballad - Vodyanitsa Banner',
      pos: '50% 30%',
      zoom: '200%',
      image: 'Surging Ballad 1.png',
      start: '2026-09-23 06:00:00',
      end: '2026-10-13 17:59:59',
      color: '#65cad7',
      url: 'https://www.hoyolab.com/article/46771531',
      timezoneDependent: true,
      showOnHome: true,
    },
    {
      name: 'La Chanson Cerise - Escoffier Banner',
      pos: '20% 18%',
      zoom: '200%',
      image: 'La Chanson Cerise 3.png',
      start: '2026-10-13 18:00:00',
      end: '2026-11-03 14:59:59',
      color: '#7af8fd',
      url: 'https://www.hoyolab.com/article/47010361',
      showOnHome: true,
    },
    {
      name: 'Chanson of Many Waters - Furina Banner',
      pos: '30% 15%',
      zoom: '200%',
      image: 'Chanson of Many Waters 5.png',
      start: '2026-11-04 06:00:00',
      end: '2026-11-24 17:59:59',
      color: '#95d6fb',
      url: 'https://www.hoyolab.com/article/47284168',
      timezoneDependent: true,
      showOnHome: true,
    },
  ],
  [
    {
      name: 'Epitome Invocation - Weapon Banner',
      pos: '40% 30%',
      zoom: '200%',
      image: 'Epitome Invocation 105.png',
      start: '2026-09-23 06:00:00',
      end: '2026-10-13 17:59:59',
      color: '#ffb169',
      url: 'https://www.hoyolab.com/article/46771531',
      timezoneDependent: true,
      showOnHome: true,
    },
    {
      name: 'Epitome Invocation - Weapon Banner',
      pos: '40% 20%',
      zoom: '200%',
      image: 'Epitome Invocation 106.png',
      start: '2026-10-13 18:00:00',
      end: '2026-11-03 14:59:59',
      color: '#ffb169',
      url: 'https://www.hoyolab.com/article/47010361',
      showOnHome: true,
    },
    {
      name: 'Epitome Invocation - Weapon Banner',
      pos: '40% 40%',
      zoom: '200%',
      image: 'Epitome Invocation 107.png',
      start: '2026-11-04 06:00:00',
      end: '2026-11-24 17:59:59',
      color: '#ffb169',
      url: 'https://www.hoyolab.com/article/47284168',
      timezoneDependent: true,
      showOnHome: true,
    },
  ],
  [
    {
      name: 'Stygian Onslaught',
      pos: '0% 40%',
      zoom: '200%',
      image: 'Stygian Onslaught.png',
      start: '2026-09-30 10:00:00',
      end: '2026-11-03 03:59:59',
      color: '#f97fdf',
      url: 'https://www.hoyolab.com/article/46791577',
    },
    {
      name: 'Stygian Onslaught',
      pos: '0% 40%',
      zoom: '200%',
      image: 'Stygian Onslaught.png',
      start: '2026-11-11 10:00:00',
      end: '2026-12-15 03:59:59',
      color: '#f97fdf',
    },
  ],
  [
    {
      name: 'Spiral Abyss',
      image: 'spiral_abyss.jpg',
      pos: '50% 20%',
      start: '2026-09-16 04:00:00',
      end: '2026-10-16 04:00:00',
      color: '#4299E1',
      description:
        "When a character deals Swirl or Stellar Swirl DMG to an opponent, a shockwave will be unleashed at the opponent's position, dealing True DMG. This effect can be triggered once every 4s.",
    },
    {
      name: 'Spiral Abyss',
      image: 'spiral_abyss.jpg',
      pos: '50% 20%',
      start: '2026-10-16 04:00:00',
      end: '2026-11-16 04:00:00',
      color: '#4299E1',
      description:
        "When a character triggers a Superconduct, Stellar-Conduct, Cryo Swirl, Stellar Swirl, Frozen, or Shatter reaction on an opponent, or deals Stellar-Conduct or Stellar Swirl DMG to an opponent, a shockwave will be unleashed at the opponent's position, dealing True DMG. This effect can be triggered once every 2s.",
    },
  ],
  [
    {
      name: 'Imaginarium Theater',
      image: 'Imaginarium Theater tmp.png',
      pos: '0% 70%',
      start: '2026-09-01 04:00:00',
      end: '2026-10-01 04:00:00',
      color: '#777df3',
      description:
        'Required Elemental Types: Hydro, Electro, and Dendro.\nOpening Characters: Columbina, Xingqiu, Cyno, Kuki Shinobu, Lauma, and Kaveh.\nSpecial Guest Stars: Odette, Sandrone, Sucrose, and Nicole.',
    },
    {
      name: 'Imaginarium Theater',
      image: 'Imaginarium Theater tmp.png',
      pos: '0% 70%',
      start: '2026-10-01 04:00:00',
      end: '2026-11-01 04:00:00',
      color: '#777df3',
      description:
        'Required Elemental Types: Hydro, Cryo, and Anemo.\nOpening Characters: Neuvillette, Barbara, Citlali, Kaeya, Wanderer, and Prune.\nSpecial Guest Stars: Ineffa, Yae Miko, Thoma, and Chiori.',
    },
    {
      name: 'Imaginarium Theater',
      image: 'Imaginarium Theater tmp.png',
      pos: '0% 70%',
      start: '2026-11-01 04:00:00',
      end: '2026-12-01 04:00:00',
      color: '#777df3',
      description:
        'Required Elemental Types: Hydro, Electro, and Geo.\nOpening Characters: Yelan, Aino, Flins, Fischl, Zhongli, and Kachina.\nSpecial Guest Stars: Qiqi, Odette, Vesna, and Jahoda.',
    },
    {
      name: 'Imaginarium Theater',
      image: 'Imaginarium Theater tmp.png',
      pos: '0% 70%',
      start: '2026-12-01 04:00:00',
      end: '2027-01-01 04:00:00',
      color: '#777df3',
      description: '',
    },
  ],
  [
    {
      name: 'Battle Pass - Moontrace',
      pos: '0% 45%',
      zoom: '200%',
      image: 'Moontrace.webp',
      start: '2026-09-23 06:00:00',
      end: '2026-11-02 03:59:59',
      color: '#b9b076',
      url: 'https://www.hoyolab.com/article/46771641',
      timezoneDependent: true,
    },
    {
      name: 'Battle Pass - Sacred Spirit Chronicle',
      pos: '0% 45%',
      zoom: '200%',
      image: 'Sacred Spirit Chronicle.webp',
      start: '2026-11-04 06:00:00',
      end: '2026-12-14 03:59:59',
      color: '#aaa2d2',
      timezoneDependent: true,
    },
  ],
];
